module.exports = __webpack_public_path__ + "static/media/ethereumNew.c46f6e6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/ethereumNew.jpg
// module id = 2388
// module chunks = 7